import {
	reMeasurementUnitConvertationConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reMeasurementUnitConvertationConstants.GetPaged.REQUEST:
		case reMeasurementUnitConvertationConstants.GetPagedAudit.REQUEST:
		case reMeasurementUnitConvertationConstants.Create.REQUEST:
		case reMeasurementUnitConvertationConstants.Remove.REQUEST:
		case reMeasurementUnitConvertationConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reMeasurementUnitConvertationConstants.GetPaged.FAILURE:
		case reMeasurementUnitConvertationConstants.GetPagedAudit.FAILURE:
		case reMeasurementUnitConvertationConstants.Create.FAILURE:
		case reMeasurementUnitConvertationConstants.Remove.FAILURE:
		case reMeasurementUnitConvertationConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reMeasurementUnitConvertationConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reMeasurementUnitConvertationConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reMeasurementUnitConvertationConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reMeasurementUnitConvertationConstants.Remove.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reMeasurementUnitConvertationConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reMeasurementUnitConvertationConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}